import Backend from 'App/Dataman-Backend';

const { apiSamples, apiSampleConditions, apiUrlSuffix } = Backend.config;

export const SAMPLES_PATHS = {
  samples: apiSamples,
  sampleConditions: apiSampleConditions,
  suffix: apiUrlSuffix,
};
